module.exports = __webpack_public_path__ + "static/media/eye.c51c073f.svg";